import axios from "../config/axios";

export async function leerEsquemaSeleccionTerapia(key) {
  return await axios.get(`/terapias/terapias/api/v3/leer_esquema`, {
    params: {
      key
    }
  });
}
export async function leerTerapias() {
  return await axios.get(`/terapias/terapias/api/v1/lista_terapias`);
}

export async function crearTerapia(key, documento, origen, creado_por) {
  return await axios.post(`/terapias/terapias/api/v1/crear_terapia`, {
    key,
    documento,
    origen,
    creado_por
  });
}

export async function leerLista(lista) {
  return await axios.get(
    `/controlador_datos/formularios/api/v1/opciones_lista`, {
      params: {
        lista
      }
    }
  );
}

export async function readSchemes(nombre_terapia) {
  return await axios.get("/terapias/terapias/api/v1/read_schemes", {
    params: {
      nombre_terapia
    }
  });
}

export async function createScheme(
  creado_por,
  nombre_terapia,
  nombre_esquema,
  sesiones
) {
  return await axios.post(`/terapias/terapias/api/v1/create_scheme`, {
    creado_por,
    nombre_terapia,
    nombre_esquema,
    sesiones
  });
}

export async function getScheme(docId) {
  return await axios.get("/terapias/terapias/api/v1/read_scheme", {
    params: {
      docId
    }
  });
}
export async function updateScheme(
  docId,
  nombre_esquema,
  nombre_terapia,
  creado_por,
  sesiones
) {
  return await axios.put("/terapias/terapias/api/v1/update_scheme", {
    docId,
    nombre_esquema,
    nombre_terapia,
    creado_por,
    sesiones
  });
}

export async function readTherapyPatient(documento) {
  return await axios.post("/terapias/terapias/api/v1/read_therapy_patient", {
    documento
  });
}

export async function createThertapyPatient(
  nivel_de_precio,
  servicio,
  id_esquema,
  nombre_terapia,
  nombre_esquema,
  documento,
  creado_por,
  iconoUrl = "",

) {
  return await axios.post(`/terapias/terapias/api/v1/create_therapy_patient`, {
    nivel_de_precio,
    servicio,
    id_esquema,
    nombre_terapia,
    nombre_esquema,
    documento,
    creado_por,
    iconoUrl
  });
}

export async function cancelTherapyPatient(docId, documento, cancelado_por) {
  return await axios.put("/terapias/terapias/api/v1/cancel_therapy_patient", {
    docId,
    documento,
    cancelado_por
  });
}
export async function readInfoTherapyPatient(documento, id_plantilla) {
  return await axios.post(
    "terapias/terapias/api/v1/read_info_therapy_patient", {
      documento,
      id_plantilla
    }
  );
}
export async function readScoresTherapyPatient(id_plantilla) {
  return await axios.get(
    "terapias/terapias/api/v1/read_score_therapy_patient", {
      params: {
        id_plantilla
      }
    }
  );
}
export async function readSummaryTherapyPatient(id_plantilla) {
  return await axios.get(
    "terapias/terapias/api/v1/read_summary_therapy_patient", {
      params: {
        id_plantilla
      }
    }
  );
}

export async function verificarplanDeAccion(
  documento,
  nombre_formulario_mejor_valor,
  nombre_seguimiento_manana,
  nombre_seguimiento_tarde,
  nombre_encuentro_plan_de_accion
) {
  try {
    return await axios.post(
      "/terapias/terapias/api/v1/plan_accion_doc_exists", {
        documento,
        nombre_formulario_mejor_valor: "Mejor valor personal",
        nombre_seguimiento_manana: "F: Mejor valor personal mañana",
        nombre_seguimiento_tarde: "F: Mejor valor personal tarde",
        nombre_encuentro_plan_de_accion: "Medicamentos asociados a plan de acción"
      }
    );
  } catch (error) {
    return error;
  }
}

export async function generatePdf(
  documento
) {
  try {
    return await axios.post(
      "/intelliticks_consultas/intelliticks/api/v1/get_pdf", {
        documento,
      }
    );
  } catch (error) {
    return error;
  }
}



// WEBPACK FOOTER //
// ./src/apiService/request/CrudTerapias.js